import React from 'react';
import { useNavigate } from 'react-router-dom';

import PageContainer from '../../../components/container/PageContainer';
import AuthLogin from './auth/AuthLogin';
import './login.css';

const Login2 = () => {
  const navigate = useNavigate();

  return (
    <PageContainer title="Вход" description="Авторизация в админ-панели лагеря">
      <div className="login-page">
        <div className="login-card">
          <div className="brand">SOL Baumanec</div>
          <p className="sub">Админ-панель лагеря</p>
          <AuthLogin />
          <div className="foot">
            Нет лагеря?{' '}
            <span className="link" onClick={() => navigate('/camp/create')}>Создать лагерь</span>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Login2;
